import React, { useEffect, useState } from 'react';
import { IoMdHeartEmpty } from 'react-icons/io';
import { BsBag, BsBagFill } from 'react-icons/bs';
import { useUserContext } from '../../context/user_context';
import axios from 'axios';
import { toast } from 'react-toastify';
import { FaRegHeart, FaHeart } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import { useCartContext } from '../../context/cart_context';
import { Stars } from '../../components';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  useDisclosure,
  Button,
} from '@chakra-ui/react';
import { formatPrice } from '../../utils/helpers';
const ProductGridView = ({
  data,
  id,
  userWishlistItems,
  userCartItems,
  checkCartStatus,
  checkWishlistStatusd,
}) => {
  const [hovered, setHovered] = useState(false);
  const { currentUser } = useUserContext();
  const { handlecartButton, setMainColor } = useCartContext();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [wishlistButtonText, setWishlistButtonText] =
    useState('Add to wishlist');
  const [cartButtonText, setCartButtonText] = useState('Add to cart');
  const [wishlistButton, setWishlistButton] = useState(
    <FaRegHeart className='heart' fill='#D3A143' />
  );
  const [cartButton, setCartButton] = useState(<BsBag fill='#D3A143' />);
  const handleWishlistButton = async (id) => {
    let userid = currentUser?.id;
    if (currentUser) {
      const response = await axios.get(
        `${process.env.REACT_APP_BACKEND_HOST}/api/user/wishlistitem/${userid}`
      );
      const array = response?.data?.data || [];

      let isPresent = array?.some((e)=>e.id==data.id);
      let options = { wishlistItem: Number(data.id) };
      if (!isPresent) {
        try {
          let res = await axios.put(
            `${process.env.REACT_APP_BACKEND_HOST}/api/user/wishlistitem/${userid}`,
            { id }
          );
          toast.success('Item added to wishlist');
          setWishlistButtonText('Remove from wishlist');
          setWishlistButton(
            <FaHeart className='heartSelected' fill='#D3A143' />
          );
        } catch (error) {
          console.error('Error adding item to wishlist:', error);
        }
      } else {
        try {
          const data = {
            wishlistItem: id,
          };
          const userid = currentUser?.id;
          const response = await axios.delete(
            `${process.env.REACT_APP_BACKEND_HOST}/api/user/wishlistitem/${userid}`,
            { data }
          );

          toast.success('Item removed from wishlist');
          setWishlistButtonText('Add to wishlist');
          setWishlistButton(<FaRegHeart className='heart' fill='#D3A143' />);
        } catch (error) {
          console.error('Error deleting item from wishlist:', error);
        }
      }
    } else {
      onOpen();
    }
  };
  useEffect(() => {
    let isMounted = true;

    try {
      if (currentUser && id) {
        const isPresent = userWishlistItems?.some((e)=>e.id==data.id);
        if (userWishlistItems !== null) {
          setWishlistButtonText(
            isPresent ? 'Remove from Wishlist' : 'Add to Wishlist'
          );
          setWishlistButton(
            isPresent ? (
              <FaHeart className='heartSelected' fill='#D3A143' />
            ) : (
              <FaRegHeart className='heart' fill='#D3A143' />
            )
          );
        } else {
          setWishlistButtonText('Add to Wishlist');
        }
        const isPresentCart = userCartItems.some(
          (order) => order.id == data.id
        );

        if (isPresentCart) {
          setCartButtonText('Remove from cart');
          setCartButton(<BsBagFill fill='#D3A143' />);
        } else {
          setCartButtonText('Add to Cart');
          setCartButton(<BsBag fill='#D3A143' />);
        }
      }
    } catch (err) {
      console.error('Error checking wishlist:', err);
    }
  }, [id]);

  const handleTouch = () => {
    setHovered(!hovered);
  };

  const handleCartButtonClick = async () => {
    if (currentUser) {
      await handlecartButton(
        data.id,
        1,
        currentUser,
        data?.size,
        setCartButtonText,
        onOpen,
        data.productCode,
        data.bestOffers,
        data.taxPrice,
        data.weight,
        data?.discountPercentage,
        data.price,
        data.price,
        data?.quantity
      );
      checkCartButtonStatus();
    } else {
      onOpen();
    }
  };

  const checkCartButtonStatus = async () => {
    let userid = currentUser?.id;

    if (currentUser) {
      const response = await axios.get(
        `${process.env.REACT_APP_BACKEND_HOST}/api/user/addtocart/${userid}`
      );

      const array = response.data.data;

      const isPresent = array.some((order) => order.id == data.id);

      if (isPresent) {
        setCartButtonText('Remove from cart');
        setCartButton(<BsBagFill fill='#D3A143' />);
      } else {
        setCartButtonText('Add to Cart');
        setCartButton(<BsBag fill='#D3A143' />);
      }
    }
  };

  
  return (
    <div key={id} className='flex w-full bg-white transition py-2 items-center'>
      <div className='w-full flex flex-col md:flex-row gap-4 md:justify-start items-center'>
        <>
         <Link to={`/collections/${data?.id}`} className='relative inline-block'>
                  {data?.quantity < 1 && (
                    <span className='absolute top-2 left-2 bg-red-600 text-white text-xs px-2 py-1 rounded-md z-10'>
                      Out of Stock
                    </span>
                  )}
        
                  <>
                    <img
                      src={data?.productImageUrl[0]}
                      alt={data?.description}
                      className='rounded-lg w-52 h-auto object-cover aspect-square'
                    />
                    <p className='mt-2 text-sm text-gray-800'>{data?.name}</p>
                  </>
                </Link>
        </>

        <div className='flex flex-col gap-3'>
          <p className='text-black text-xl'>{data?.description}</p>
          <Stars stars={data?.rating} reviews={data?.numberOfReviews} />
          <div className='flex md:flex-row flex-col gap-2 text-xl lg:text-xl'>
            <p className='font-medium text-black'>{formatPrice(data?.subPrice)}</p>
            {data?.discountPercentage > 0 && (
              <>
                <p className='line-through text-gray-500'>
                 
                  {formatPrice(Number(data?.price) + Number(data?.discountPrice))}
                </p>
                <p className=' text-red-600'>({formatPrice(data?.discountPrice)} Off)</p>
              </>
            )}
          </div>
          <div className='flex gap-6'>
            <div
              className='flex gap-2 justify-center items-center'
              onClick={() => handleWishlistButton(data.id)}
            >
              <p className='text-xl lg:text-2xl'>{wishlistButton}</p>
              <p>{wishlistButtonText}</p>
            </div>
            <div className='flex gap-2 justify-center items-center'>
              <p
                className='text-xl lg:text-2xl cursor-pointer'
                onClick={handleCartButtonClick}
              >
                {cartButton}
              </p>
              <p>{cartButtonText}</p>
            </div>
          </div>
        </div>
      </div>
      '{' '}
      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Please Login</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <p>Please login to add items to your cart and wishlist.</p>
          </ModalBody>
          <ModalFooter>
            <Button colorScheme='blue' mr={3} onClick={onClose}>
              Close
            </Button>
            <Link to='/login'>
              <Button variant='ghost'>Login</Button>
            </Link>
          </ModalFooter>
        </ModalContent>
      </Modal>
      '
    </div>
  );
};

export default ProductGridView;
